import { Navigate, RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/organized/'].update({
        staticData: { title: { page: { param: 'tab', keys: { upcoming: 'Title.OrganizedUpcoming', ended: 'Title.OrganizedEnded' } } } },
        component: () => <Navigate to="/organized/$tab" params={{ tab: 'upcoming' }} />
    });
};
